import type { ChainArch } from "@opensea/graphql"
import {
  CORE_LOGO_URL,
  METAMASK_LOGO_URL,
  PHANTOM_LOGO_URL,
  RABBY_LOGO_URL,
  SOLFLARE_LOGO_URL,
  TRUST_WALLET_LOGO_URL,
  ZERION_LOGO_URL,
} from "../../../../../lib/assets"

const GLYPH_LOGO_URL = "https://i.ibb.co/TxcwPQyr/Group-12489-1.png"
const VEEFRIENDS_LOGO_URL =
  "https://media.veefriends.com/image/upload/v1742394679/veefriends/v3/logos/logo-cat-white.png"

type WalletOption = {
  id: string
  name: string
  icon: string
  href: string
  chainArchitectures: ChainArch[]
}

const TRUST_WALLET = {
  id: "com.trustwallet.app",
  name: "Trust Wallet",
  icon: TRUST_WALLET_LOGO_URL,
  href: "https://trustwallet.com/download",
  chainArchitectures: ["EVM", "SVM"],
} satisfies WalletOption

export const WALLET_OPTIONS: WalletOption[] = [
  {
    id: "io.metamask",
    name: "MetaMask",
    icon: METAMASK_LOGO_URL,
    href: "https://metamask.io/download",
    chainArchitectures: ["EVM"],
  },
  {
    id: "io.zerion.wallet",
    name: "Zerion",
    icon: ZERION_LOGO_URL,
    href: "https://zerion.io/download",
    chainArchitectures: ["EVM"],
  },
  {
    id: "app.phantom",
    name: "Phantom",
    icon: PHANTOM_LOGO_URL,
    href: "https://phantom.app/download",
    chainArchitectures: ["EVM", "SVM"],
  },
  TRUST_WALLET,
  {
    id: "app.core.extension",
    name: "Core",
    icon: CORE_LOGO_URL,
    href: "https://chrome.google.com/webstore/detail/core/agoakfejjabomempkjlepdflaleeobhb",
    chainArchitectures: ["EVM"],
  },
  {
    id: "io.rabby",
    name: "Rabby Wallet",
    icon: RABBY_LOGO_URL,
    href: "https://chromewebstore.google.com/detail/rabby-wallet/acmacodkjbdgmoleebolmdjonilkdbch",
    chainArchitectures: ["EVM"],
  },
  {
    id: "com.solflare",
    name: "Solflare",
    icon: SOLFLARE_LOGO_URL,
    href: "https://www.solflare.com/download",
    chainArchitectures: ["EVM", "SVM"],
  },
  {
    id: "io.useglyph.privy",
    name: "Glyph",
    icon: GLYPH_LOGO_URL,
    href: "https://www.glyph.so/",
    chainArchitectures: ["EVM"],
  },
  {
    id: "io.veefriends.privy",
    name: "VeeFriends Wallet",
    icon: VEEFRIENDS_LOGO_URL,
    href: "https://veefriends.com/",
    chainArchitectures: ["EVM"],
  },
]

export const NAME_TO_WALLET_MAP: Record<string, WalletOption | undefined> = {
  Trust: TRUST_WALLET,
}
